<template>
  <div class="table-header">
    <div class="table-throw">
      <div v-for="header in headers" class="table-th" :key="header.id" :class="header.class">
        {{$t(header.tlabel)}}
        <Tooltip
          class="item tooltipicon"
          effect="dark"
          placement="bottom"
          :open-delay="300"
          v-if="toolTipMapping && toolTipMapping[header.toolTipColumn]"
        >
          <div
            slot="content"
            class="tooltipcontent"
          >{{toolTipMapping[header.toolTipColumn]}}</div>
          <button>
            <svgicon name="info-black" width="12" height="12" :original="true" />
          </button>
        </Tooltip>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['headers', 'toolTipMapping'],
};
</script>
